import { z } from 'zod'
import { PaymentInterval } from '@/types/purchase/PaymentInterval'

export const K8sQuotaLimits = z.object({
  cpu_cores: z.number(),
  memory_gib: z.number(),
  pvcs: z.number(),
  storage_gib: z.number()
})

export const K8sPlanInfo = z.object({
  product_slug: z.string(),
  product_name: z.string(),
  billing_type: z.enum(['payg', 'fixed']),
  price_cents: z.number(),
  quotas: K8sQuotaLimits,
  // The current subscription's term; the tiers bill monthly.
  billing_freq: PaymentInterval.optional(),
  // What one term bills on the account's basis. On net it is rounded once per
  // term, so it can differ from price_cents times the term's months.
  term_price_cents: z.number().optional()
})

export const K8sTierOption = z.object({
  product_id: z.number(),
  product_slug: z.string(),
  product_name: z.string(),
  price_cents: z.number(),
  quotas: K8sQuotaLimits,
  is_current: z.boolean()
})

export const K8sPaygComparison = z.object({
  payg_product_id: z.number(),
  projected_cents: z.number(),
  savings_cents: z.number(),
  savings_percent: z.number(),
  quotas: K8sQuotaLimits,
  days_remaining: z.number()
})

export const K8sPlanOptions = z.object({
  current_plan: K8sPlanInfo,
  tiers: z.array(K8sTierOption),
  payg_comparison: K8sPaygComparison.nullable().optional()
})

export const K8sSwitchPlanResult = z.object({
  status: z.string(),
  billing_type: z.string(),
  new_plan: z.string(),
  new_quotas: K8sQuotaLimits
})
